export default "__VITE_ASSET__77e6f782__"